import {
  Badge,
  Button,
  PageToolbar,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SlidersHorizontal,
} from '@spcc/uikit';
import type { AddressbookToolbarProps } from '../types';

export function AddressbookToolbar({
  searchPlaceholder,
  searchValue,
  onSearchChange,
  activeFilterCount,
  filterButtonLabel,
  onOpenFilterDrawer,
  statusFilterOptions,
  statusFilterValue,
  onStatusFilterChange,
  isRTL,
}: AddressbookToolbarProps) {
  return (
    <PageToolbar
      searchPlaceholder={searchPlaceholder}
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      isRTL={isRTL}
    >
      <Button
        type="button"
        variant="outline"
        onClick={onOpenFilterDrawer}
        className="h-10 gap-2"
      >
        <SlidersHorizontal className="h-4 w-4" />
        <span>{filterButtonLabel}</span>
        {activeFilterCount > 0 && (
          <Badge variant="secondary" className="h-5 px-1.5 text-xs">
            {activeFilterCount}
          </Badge>
        )}
      </Button>

      {/* Status Filter */}
      <Select value={statusFilterValue} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-40 h-10 glass-card border-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {statusFilterOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </PageToolbar>
  );
}
